const mockEvents = {
  city: {
    id: 1007700,
    city: 'München',
    lat: 48.14,
    lon: 11.58,
    state: '',
    country: 'de',
    zip: 'meetup3',
    member_count: 1257
  },
  events: [
    {
      created: 1552577540000,
      duration: 7200000,
      id: '259762490',
      name: 'Rust libp2p',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1556812800000,
      local_date: '2019-05-02',
      local_time: '18:00',
      updated: 1553270253000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 14,
      venue: {
        id: 26268777,
        name: 'Instana - WeWork',
        lat: 48.14487838745117,
        lon: 11.576659202575684,
        repinned: true,
        address_1: 'Oskar-von-Miller-Ring 20',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1532692208000,
        name: 'Munich IPFS',
        id: 29367386,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munich-IPFS-User-Group',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munich-IPFS-User-Group/events/259762490/',
      description: '<p>(This event is co-organized with the Rust User Group: <a href="https://www.meetup.com/de-DE/rust-munich/events/259984522/" class="linkified">https://www.meetup.com/de-DE/rust-munich/events/259984522/</a>)</p> <p>IPFS is meant to be not just a number of programs from protocol labs, but a set of cleanly specified open protocols that can be implemented in many different languages for everybody that needs a peer to peer networking stack to write p2p applications.</p> <p>Pierre Krieger, also known as tomaka on github and twitter, is going to talk about the rust implementation of libp2p that is being developed for parity.io.</p> ',
      visibility: 'public'
    },
    {
      created: 1554280915000,
      duration: 7200000,
      id: '260303680',
      name: 'Technology Radar Vol. 20 Presentation',
      rsvp_limit: 106,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557248400000,
      local_date: '2019-05-07',
      local_time: '19:00',
      updated: 1555516043000,
      utc_offset: 7200000,
      waitlist_count: 22,
      yes_rsvp_count: 106,
      venue: {
        id: 25852478,
        name: 'ThoughtWorks Munich ',
        lat: 48.135860443115234,
        lon: 11.613353729248047,
        repinned: true,
        address_1: 'Bothestraße 11',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1413448074000,
        name: 'ThoughtWorks Munich',
        id: 17658472,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'ThoughtWorks-Muenchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/ThoughtWorks-Muenchen/events/260303680/',
      description: '<p>*** Registrations via our website ***<br/><a href="https://thoughtworks.com/technology_radar_de" class="linkified">https://thoughtworks.com/technology_radar_de</a></p> <p>Adopt, trial, assess or hold?<br/>Get ahead of the latest technology trends.</p> <p>The Technology Radar, based on our observations, conversations and experiences with our customers, covers both existing and emerging technologies.</p> <p>The report divides the trends into four groups: Techniques, platforms, tools, programming languages and frameworks. Within these groups, each trend has a recommendation: "Hold" for technologies that are not initially recommended for use; "Assess" for technologies that require further evaluation; "Trial" for technologies that are ready for use; and "Adopt" for mature technologies.</p> <p>Learn more about the latest technology and join us for the event in our Munich office.</p> <p>We are looking forward to welcome you!</p> <p>Agenda:</p> <p>18:30 - 19:00 Registration and Drinks</p> <p>19:00 - 20:30 Technology Radar Presentation (incl. Q&amp;A)</p> <p>20:30 - 22:00 Get Together with drinks &amp; fingerfood</p> <p>The presentation will be held in English.</p> <p>---</p> <p>*** Registrierung über unsere Website ***<br/><a href="https://thoughtworks.com/de/technology_radar_de" class="linkified">https://thoughtworks.com/de/technology_radar_de</a></p> <p>Adopt, trial, assess oder hold?<br/>Erfahre von unseren Experten mehr zu den neuesten Technologietrends.</p> <p>Der Technology Radar, der auf unseren Beobachtungen, Gesprächen und Erfahrungen mit unseren Kunden beruht, behandelt sowohl existierende als auch neu aufkommende Technologien.</p> <p>Der Report teilt die Trends in vier Gruppen auf: Techniken, Plattformen, Tools sowie Programmiersprachen und Frameworks. Innerhalb dieser Gruppen wird jeder Trend mit einer Empfehlung versehen: „Hold“ für Technologien, von deren Verwendung vorerst abgeraten wird; „Assess“ für Technologien, die einer weiteren Evaluation bedürfen; „Trial“ für Technologien, die einsatzbereit sind und „Adopt“ für ausgereifte Technologien.</p> <p>Erfahre mehr über die neusten Technologietrends und melde dich für unsere Technology Radar Präsentation in München an.</p> <p>Wir freuen uns auf dich!</p> <p>Agenda:</p> <p>18:30 - 19:00 Registrierung und Drinks</p> <p>19:00 - 20:30 Technology Radar Präsentation (inkl. Q&amp;A)</p> <p>20:30 - 22:00 Get Together mit Drinks &amp; Fingerfood</p> <p>Die Präsentation findet auf Englisch statt.</p> ',
      visibility: 'public'
    },
    {
      created: 1553601323000,
      duration: 25200000,
      id: '260079692',
      name: 'Kotlin Saturday Workshop',
      rsvp_limit: 25,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1556355600000,
      local_date: '2019-04-27',
      local_time: '11:00',
      updated: 1554301095000,
      utc_offset: 7200000,
      waitlist_count: 41,
      yes_rsvp_count: 25,
      venue: {
        id: 26244427,
        name: 'JetBrains GmbH',
        lat: 48.13737487792969,
        lon: 11.52295970916748,
        repinned: true,
        address_1: 'Elsenheimerstraße 49',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1421043158000,
        name: 'Kotlin User Group Munich - KUG Munich',
        id: 18325305,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Kotlin-User-Group-Munich',
        who: 'KUG-Hacker',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Kotlin-User-Group-Munich/events/260079692/',
      description: '<p>Do you want to learn Kotlin, but don’t know where to start?<br/>Here’s the deal.<br/>We will have a Kotlin Workshop on April 27th, from 11.00 in the Munich office!</p> <p>We will start with a live coding introduction into the basics of the Kotlin language. We will discuss in depth the features of the language and cover fluent APIs, higher-order functions, lambdas, and type-safe DSLs. You’ll be able to see how these language features are used in real life examples. You will get an understanding of the magic behind type-safe builders. Kotlin Coroutines will be covered next, where you will be able to explain afterwards why Coroutines are not threads, not Fibers. You’ll learn how ‘suspend’ functions are used to simplify callback driven programming and how they can help you to turn callback-style code into linear looking code. With Kotlin you can compile your code for JVM, Android, iOS, Mac, and JS. With multiplatform projects, you may easily reuse your Kotlin code across different platforms. Logic, business rules, utilities, and RPC are all good examples of possible code parts you should reuse. You’ll see how Kotlin code can be used in React frontend, JVM backend, Android and iOS, and Native. Let\'s have some fun!</p> <p>This Kotlin Workshop will take place on April 27th, from 11.00 to 18.00 at JetBrains Event Space in Munich. Please bring with you a laptop with IntelliJ IDEA installed and a charger; there are going to be a few hands-on exercises.</p> ',
      visibility: 'public'
    },
    {
      created: 1554728176000,
      duration: 10800000,
      id: '260445923',
      name: 'Kotlin Users Group Meetup May',
      rsvp_limit: 90,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557161100000,
      local_date: '2019-05-06',
      local_time: '18:45',
      rsvp_close_offset: 'PT44H',
      updated: 1554978288000,
      utc_offset: 7200000,
      waitlist_count: 26,
      yes_rsvp_count: 90,
      venue: {
        id: 26112492,
        name: 'Google',
        lat: 48.143035888671875,
        lon: 11.541084289550781,
        repinned: true,
        address_1: 'Erika-Mann-Straße 33',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1421043158000,
        name: 'Kotlin User Group Munich - KUG Munich',
        id: 18325305,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Kotlin-User-Group-Munich',
        who: 'KUG-Hacker',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Kotlin-User-Group-Munich/events/260445923/',
      description: '<p>Hello Kotliners. Join us in our May gathering at Google office.</p> <p>Agenda:</p> <p>19:00 - Opening doors</p> <p>19:15 - Michal Harakal - Kotlin multiplatform roller-coaster ride or how I\'ve rewritten a conference app over the weekend.</p> <p>19.55 - Shagen Ogandzhanian (JetBrains) - Kotlin and JS interop, what\'s next. How to use javascript libraries in Kotlin world</p> <p>20.30 - Leonid Popescu (Payworks) - Hybrid SDKs or how we started with Kotlin/Multiplatform without trashing the existing code base</p> <p>Have you been working on a project with Kotlin? Is there a library you would like to discuss? Do you want to try public speaking?<br/>Message us, come and have fun sharing your Kotlin story!</p> ',
      how_to_find_us: 'We will need the full list of guests to print badges beforehand. RSVP will be closed a few days before to implement it.',
      visibility: 'public'
    },
    {
      created: 1554313880000,
      duration: 10800000,
      id: '260314997',
      name: 'Exceptions Demystified',
      rsvp_limit: 200,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1556211600000,
      local_date: '2019-04-25',
      local_time: '19:00',
      rsvp_open_offset: 'PT336H',
      updated: 1556120190000,
      utc_offset: 7200000,
      waitlist_count: 53,
      yes_rsvp_count: 200,
      venue: {
        id: 26112492,
        name: 'Google',
        lat: 48.143035888671875,
        lon: 11.541084289550781,
        repinned: true,
        address_1: 'Erika-Mann-Straße 33',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1381869297000,
        name: 'MUC++',
        id: 10704512,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'MUCplusplus',
        who: 'C++ aficionados',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/MUCplusplus/events/260314997/',
      description: '<p>Exception Handling is probably one of the most controversial features in C++, with many code bases outright banning them from the start, or only allowing their use in very specific cases. The reasons for this are often unclear and founded on premises that are not well understood.</p> <p>In this talk, we will explain exception handling from the bottom up, taking a close look at what a compiler actually has to do to implement the mechanism. Instead of focusing on a specific implementation, we will approach the problem from a more abstract, language-design point of view, allowing us to explore the different approaches an implementation could choose. In the end, we will gain a deeper understanding for the problems associated with the feature and how they could be mitigated in the future by alternative language features like the proposed static exceptions.</p> <p>Agenda:<br/>18:30 -- Entry<br/>19:00 -- Welcome at Google with Food and Drinks<br/>19:30 -- 1. Lightning Talk<br/>~19:45 -- 2. Lightning Talk<br/>~20:00 -- Exceptions Demystified (Andreas Weis)<br/>~21:15 -- Open Discussions<br/>22:00 -- Official End</p> ',
      visibility: 'public'
    },
    {
      created: 1554987750000,
      duration: 19800000,
      id: '260535959',
      name: 'Google I/O Extended Munich 2019',
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557243000000,
      local_date: '2019-05-07',
      local_time: '17:30',
      updated: 1555494305000,
      utc_offset: 7200000,
      waitlist_count: 88,
      yes_rsvp_count: 102,
      venue: {
        id: 26112492,
        name: 'Google',
        lat: 48.143035888671875,
        lon: 11.541084289550781,
        repinned: true,
        address_1: 'Erika-Mann-Straße 33',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1448316136000,
        name: 'GDG Munich Android',
        id: 19149051,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'GDG-Munich-Android',
        who: 'Humble Android Coders',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/GDG-Munich-Android/events/260535959/',
      description: '<p>Google I/O 2019! Let\'s enjoy the live stream of the event together in Munich.</p> <p>You were too late to get a spot? There\'s a **second** location at 1und1 - check this event: <a href="https://www.meetup.com/GDG-Munich-Android/events/260639431/" class="linkified">https://www.meetup.com/GDG-Munich-Android/events/260639431/</a></p> <p>Preliminary Agenda:<br/>17:30 Arrival, networking, food &amp; drinks<br/>19:00 Key Note<br/>20:45 Lightning talks (5-7 minutes, contact us if you want to present!)<br/>21:45 Developer Key Note<br/>22:45 End</p> <p>NOTE: If you are attending, we need your first and last name. If your meetup profile does not show your real name, please change that or reach out to us and tell us. This is required for attending the meeting.</p> <p>Lightning talks: Please reach out to us if you would like to present. Tell us about your topic (send slides if you have already them or just a very short outline otherwise) and how long your talk will be. Your topic should also consider that we are expecting a mixed group including "non-Android" people.</p> ',
      visibility: 'public',
      pro_is_email_shared: false
    },
    {
      created: 1555409541000,
      duration: 7200000,
      id: '260666142',
      name: 'Fuckup Nights Munich - Vol. II 2019',
      rsvp_limit: 150,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561568400000,
      local_date: '2019-06-26',
      local_time: '19:00',
      rsvp_close_offset: 'PT168H',
      updated: 1556110482000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 47,
      venue: {
        id: 26328091,
        name: 'IHK Academy Munich',
        lat: 48.124412536621094,
        lon: 11.59816837310791,
        repinned: true,
        address_1: 'Orleansstraße 10-12',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1443688096000,
        name: 'TechDivision TechTalk München',
        id: 18985124,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'TechDivision-TechTalk-Munchen',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/TechDivision-TechTalk-Munchen/events/260666142/',
      description: '<p>Bei diesem Event handelt es sich um eine inzwischen weltweite Bewegung, die mittlerweile in mehr als 300 Städten in über 80 Ländern weltweit stattfindet! Jetzt gibt es dieses Event auch offiziell in München!</p> <p>"Fuckup Nights" klingt anrüchig? Ist es aber nicht! An diesem Abend haben vier Personen das Wort, die zur Abwechslung mal nicht von großen Erfolgsgeschichten erzählen, sondern mit Witz, Humor und aller Offenheit davon berichten, wie es auch mal schief laufen kann - damit sind wir bei den sog. Fuck Ups.</p> <p>Schaut Euch einfach das Video dazu an: <a href="https://www.youtube.com/embed/xtH6zGSeuDI" class="embedded">https://www.youtube.com/embed/xtH6zGSeuDI</a></p> <p>Ein paar Impressionen von der ersten Fuckup Night Munich in diesem Jahr bei HIRMER mit 270 Teilnehmern bekommt ihr unter nachfolgendem Link: <a href="https://www.youtube.com/watch?v=nBUtn5o9-Tc" class="embedded">https://www.youtube.com/watch?v=nBUtn5o9-Tc</a></p> <p>Fehler passieren eben und das im privaten Umfeld wie auch im Job - vom Ein-Mann Betrieb bis hin zu globalen Konzernen, nur wird darüber häufig nicht oder kaum gesprochen. Genau das wollen wir ändern! Im Rahmen der Fuckup Nights, soll genau darüber ganz offen gesprochen und diskutiert werden!</p> <p>ABER WARUM DAS GANZE?<br/>Ganz einfach! Weil man bekanntlich aus Fehlern lernt! Etwas erst gar nicht zu versuchen ist am Ende viel schlechter, wie etwas auszuprobieren und dann zu scheitern. Also nur wenn man etwas wagt und ausprobiert, kann man erst sicher sein, ob es überhaupt funktioniert. Wir sind daher überzeugt davon, dass man aus den meisten Misserfolgen etwas gewinnen und mitnehmen kann. Daher werden wir sicherlich auch einen unserer unzähligen FuckUps präsentieren. Ganz offen und ohne Filter!</p> <p>Die „Fuckup-Nights“ sind also dazu da, öffentlich über schief gelaufenen Projekte, Arbeiten und Ideen zu sprechen und diese Erfahrung mit der Community zu teilen. In lockerer Atmosphäre werden an diesem Abend wertvolle Erfahrungen von erfolgreichen Managern, Unternehmen und Startups weitergegeben, um daraus zu lernen. Natürlich gibt´s auch Snacks und Getränke, damit das Ganze nicht zu trocken wird!</p> <p>Es warten einige Überraschungen... ;-)</p> <p>WICHTIG: Die Teilnahme ist ausschließlich nach vorheriger Anmeldung über nachfolgenden Link möglich: <a href="https://fuckupnights.com/munich/" class="linkified">https://fuckupnights.com/munich/</a><br/>First come - first serve!</p> ',
      visibility: 'public'
    },
    {
      created: 1554479262000,
      duration: 10800000,
      id: '260373931',
      name: 'AWS UG May Event',
      rsvp_limit: 120,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557937800000,
      local_date: '2019-05-15',
      local_time: '18:30',
      updated: 1554482034000,
      utc_offset: 7200000,
      waitlist_count: 4,
      yes_rsvp_count: 120,
      venue: {
        id: 26303862,
        name: 'NTT DATA Deutschland GmbH',
        lat: 48.18416976928711,
        lon: 11.587780952453613,
        repinned: true,
        address_1: 'Hans-Döllgast-Straße 26',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1400514197000,
        name: 'Munich AWS User Group',
        id: 14546712,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'AWS-Munich',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/AWS-Munich/events/260373931/',
      description: '<p>It\'s May and the summer is coming to the most beautiful city in the world!<br/>But this doesn\'t stop us from visiting the fifth sponsor this year!<br/>We\'re very thankful that NTT Data (<a href="https://de.nttdata.com/" class="linkified">https://de.nttdata.com/</a>) is providing food, drinks and their offices for our meetup!</p> <p>AGENDA:<br/>18:30 - Doors open, networking, drinks, food<br/>19:00 - Markus (Team Internet AG) - Recent AWS announcements<br/>19:45 - Krasimir Dzhigovechki &amp; Wolfgang Unger (NTT Data) - Container Orchestration in AWS: ECS vs. EKS<br/>On AWS you can run containers either with ECS or the new AWS service EKS.<br/>While ECS is quite established and well supported on AWS, EKS was launched much later, to finally support Kubernetes on AWS.<br/>We want to show up the differences between ECS and EKS, talk about advantages and disadvantages of both solutions and point<br/>Out to you, in which situation or use case you should choose the one or the other.<br/>We will present live demos on both services and then make a comparison of both container services.<br/>20:45 - More drinks, more networking</p> <p>If you have an office or coworking space where we can meet [masked] people), want to sponsor drinks/food or have a (lightning) talk you want to present - please let us know!</p> ',
      visibility: 'public'
    },
    {
      created: 1555342805000,
      duration: 7200000,
      id: '260643142',
      name: 'PyData April: Talks on Kotlin & Computer Vision',
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1556557200000,
      local_date: '2019-04-29',
      local_time: '19:00',
      updated: 1555512566000,
      utc_offset: 7200000,
      waitlist_count: 12,
      yes_rsvp_count: 100,
      venue: {
        id: 26090924,
        name: 'JetBrains Event Space',
        lat: 48.13762664794922,
        lon: 11.5233154296875,
        repinned: true,
        address_1: 'Elsenheimerstraße 47A',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1469524975000,
        name: 'PyData Munich',
        id: 20225730,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'PyData-Munchen',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/PyData-Munchen/events/260643142/',
      description: '<p>PyData Munich is back with a couple of accessible data science tutorials!</p> <p>Schedule:<br/>- 18:30 Doors open<br/>- 19:00 Welcome to PyData Munich<br/>- 19:10 “Kotlin 💕 Data Science?” by Preslav Rachev, Senior Backend Engineer @ KI labs</p> <p>Software engineering and data science are two very different disciplines. Accommodating both in the same project is not trivial. The key to success relies on developers and data scientists having a middle ground where they could do their work productively, and without affecting the other side. Preslav\'s talk will try to revisit Kotlin as a language potentially suiting both sides. He will reflect on its advantages, and also the current roadblocks.</p> <p>Preslav is a Java/Python double agent with over 10 years of cumulative programming experience (both in industry and academia). He loves open-source software, making music, writing, and distance running.</p> <p>- 19:55 “Introduction to Computer Vision” by Anton Kasyanov, Senior Machine Learning Engineer @ DataRobot</p> <p>The talk is aimed at the engineers who are curious about the area and have no prior experience with it. The main goal is to give the feel of what is it all about, what problems can be solved and some basic methods to do that.</p> <p>Anton works as a Senior Machine Learning Engineer in DataRobot for almost two years. Prior to that, he did a lot of backend and ML development using Python. He got his Computer Science Masters degree in RWTH Aachen (Germany) with a focus on Computer Vision.</p> <p>- 20:40 Job advertisements and networking with beer and pizza</p> <p>Many thanks to JetBrains (<a href="https://www.jetbrains.com/" class="linkified">https://www.jetbrains.com/</a>) for hosting and sponsoring this event!</p> <p>Hope to see you there!<br/>Connor &amp; Nithish</p> <p>P.S.: If you are interested in giving a talk or hosting an event, please contact one of the organizers!<br/>If you are looking for inspiration for a talk topic or want to request one, please check out the ever-growing lists of topics here: <a href="https://docs.google.com/document/d/1wrdv27B7UGRJelbk8EQdHmBZ8uuO0I4q2JlJrsiCGlI/edit?usp=sharing" class="linkified">https://docs.google.com/document/d/1wrdv27B7UGRJelbk8EQdHmBZ8uuO0I4q2JlJrsiCGlI/edit?usp=sharing</a></p> ',
      visibility: 'public',
      pro_is_email_shared: false
    },
    {
      created: 1371224928000,
      id: 'drpzdgyzhblb',
      name: 'Ruby User Group Meetup',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557334800000,
      local_date: '2019-05-08',
      local_time: '19:00',
      updated: 1507810525000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      group: {
        created: 1370808069000,
        name: 'Munich Rubyshift, Ruby User Group',
        id: 8851722,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munich-Rubyshift-Ruby-User-Group',
        who: 'Rubyists',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munich-Rubyshift-Ruby-User-Group/events/drpzdgyzhblb/',
      description: '<p>We\'re actively searching for speakers! Want to become one? Ping us!</p> ',
      visibility: 'public'
    },
    {
      created: 1554185779000,
      duration: 10800000,
      id: '260271104',
      name: 'Flutter talks in June',
      rsvp_limit: 120,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1559836800000,
      local_date: '2019-06-06',
      local_time: '18:00',
      updated: 1555153661000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 35,
      group: {
        created: 1543101111000,
        name: 'Flutter Munich',
        id: 30587470,
        join_mode: 'approval',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Flutter-Munich',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Flutter-Munich/events/260271104/',
      description: '<p>PRESENTATIONS:</p> <p>🎤 Krzysztof Sroka 🎤<br/>60 FPS or bust 📈<br/>⏱30 min</p> <p>Flutter lets you write incredibly smooth animations with its promise of 60 FPS refresh rate. But to achieve that you need to make sure that you don\'t slow yourself down. In the talk I\'ll describe how Flutter renders widgets, what does it mean for you, present some common pitfalls you should avoid, and finally show what you can do using the provided debugging tools.</p> <p>CONTRIBUTE:</p> <p>🗣️ If you would like to share your experience with Flutter, please feel free to contact me at any time. We have slots for presentations at this event and we are already organizing the next events.</p> <p>🍕 Would you or your company like to host one of our upcoming events? Send me a message!</p> ',
      visibility: 'public'
    },
    {
      created: 1552730271000,
      duration: 10800000,
      id: '259817783',
      name: '2. Agiles Projektmanagement Trendforum am 27.Juni 2019 (WERK1 München)',
      rsvp_limit: 80,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1561654800000,
      local_date: '2019-06-27',
      local_time: '19:00',
      updated: 1553721073000,
      utc_offset: 7200000,
      waitlist_count: 27,
      yes_rsvp_count: 80,
      venue: {
        id: 26052503,
        name: 'WERK1 München',
        lat: 48.123779296875,
        lon: 11.608209609985352,
        repinned: true,
        address_1: 'Atelierstraße 29',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1430647334000,
        name: 'Projektmanagement Meetup Roundtable',
        id: 18574027,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Projektmanagement-Meetup-Roundtable',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Projektmanagement-Meetup-Roundtable/events/259817783/',
      description: '<p>2. Agiles Projektmanagement Trendforum / Meetup am Donnerstag, den 27. Juni 2019 bei WERK1, München</p> <p>Referenten:<br/>Herr Andreas Hock:<br/>Partner, 3Pworx GmbH, seit ca. 20 Jahren zertifizierter Trainer und Berater für klassisches, agiles und hybrides Projekt- und Portfoliomanagement, PM-Publizist und Buchautor, Erfolgscoach, Motivator und Wissensmanager.</p> <p>Herr Steffen Jakob:<br/>Steffen Jakob ist Diplom-Wirtschaftsingenieur und leitet seit 2013 den Geschäftsbereich Projekt- und Requirements-Management der Haufe Gruppe. In dieser Funktion verantwortet er das Haufe-Projektportfolio.<br/>Er begann seine Karriere bei einem großen internationalen Medienunternehmen und arbeitete anschließend in unterschiedlichen Führungsfunktionen bei IT-Beratungsunternehmen.</p> <p>Herr Timo Bass:<br/>Timo Bass leitet den Bereich Strategische Projektportfolio Steuerung @ CreditPlus (Credit Agricole). Er ist PMP nach PMI, SAFe Program Consultant (SPC), Design Thinking Coach und war früher u.a. für das Beratungshaus Accenture Strategy erfolgreich tätig.</p> <p>Agenda:<br/>18:00 Uhr - Empfang, Get-Together I mit Drinks und Snacks sowie erstes Kennenlernen</p> <p>19:00 Uhr - Begrüßung und Einführung durch 3Pworx GmbH, WERK1</p> <p>19:15 Uhr – Vortrag 1: -&gt; „Vom Religionskrieg zur Ökumene“ – klassische und agile Vorgehensweisen bei der Haufe-Group</p> <p>Vortrag Haufe-Group von Herrn Steffen Jakob</p> <p>20:00 Uhr – Vortrag 2: Eine gemeinsame Reise zu einer Lean &amp; Agile Organisation – Mehr eine Revolution als Transformation!</p> <p>Vortrag von Credit Plus Bank, Herr Timo Bass (Leiter Strategische Portfoliosteuerung)</p> <p>21:00 Uhr – Vortrag 3: Agile Methoden im Vergleich – Scrum vs. KANBAN vs. SAFe, usw.</p> <p>Wie finde ich die „richtige“ agile Methodik, welche idealerweise zu meinem Unternehmen und agilen Projekten passt.</p> <p>Vortrag von Herrn Andreas Hock, Partner 3Pworx GmbH</p> <p>21:30 Uhr - Gemütliches Ausklingen in der Werk1 Lounge mit Snacks &amp; Drinks</p> <p>ca. 22:00 Uhr - Ende des 3Pworx 2. Agilen Trendforums Juni 2019</p> <p>Selbstverständlich ist diese Veranstaltung für Sie kostenfrei.</p> <p>Genaue Veranstaltungsdetails:<br/>Termin: Donnerstag, den 27. Juni 2019; Zeit 18:00 – ca. 22:00 Uhr<br/>Ort: WERK1</p> <p>Anmeldung:<br/>Bitte senden Sie uns Ihre Teilnehmerdaten über das Anmeldeformular auf www.3pworx.com oder senden Sie eine kurze Email an [masked] . Eine Anmeldung ist auch über das XING – Event oder die Meetup-Gruppe möglich.</p> <p>Gerne können Sie die Einladung, wenn Sie möchten, auch an Kolleginnen oder Kollegen sowie Interessierte des PM Meetups 2019 weiterleiten oder weiterempfehlen.<br/>Mit freundlichen Grüßen<br/>Ihr 3Pworx-Team</p> ',
      how_to_find_us: 'https://www.werk1.com',
      visibility: 'public'
    },
    {
      created: 1548946504000,
      duration: 27000000,
      id: '258560164',
      name: 'Global DevOps Bootcamp 2019',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1560582000000,
      local_date: '2019-06-15',
      local_time: '09:00',
      rsvp_open_offset: 'PT1190H',
      updated: 1550157995000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 8,
      group: {
        created: 1397242023000,
        name: 'Agile Munich',
        id: 13860382,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'AgileMunich',
        who: 'Agile Practitioners',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/AgileMunich/events/258560164/',
      description: '<p>As with previous two years, we\'re bringing you this year\'s Global DevOps Bootcamp on June 15th. Stay tuned and mark your calendars...</p> <p>Get in touch if you wish to sponsor.</p> <p>More details to follow shortly.</p> ',
      visibility: 'public'
    },
    {
      created: 1554382076000,
      duration: 7200000,
      id: '260339373',
      name: 'Design Thinking bei On Demand Mikroversicherungen mittels Blockchain Technologie',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1556208000000,
      local_date: '2019-04-25',
      local_time: '18:00',
      updated: 1554382076000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 30,
      venue: {
        id: 26170224,
        name: 'Zielpuls GmbH München',
        lat: 48.18381118774414,
        lon: 11.586676597595215,
        repinned: false,
        address_1: 'Domagkstraße 14',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1521464337000,
        name: 'TechTalk at Zielpuls',
        id: 27876639,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'TechTalk-Zielpuls',
        who: 'Mitglieder',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/TechTalk-Zielpuls/events/260339373/',
      description: '<p>Unser TechTalk@Zielpuls im April wird von unseren Beratern Alexander Lipski und Dr. Timm Bergholz gestaltet. Sie bringen uns ihre Erfahrungen aus der Entwicklung eines Blockchain Use Cases mit.</p> <p>Unser Vortrag wird folgende Schwerpunkte behandeln:<br/>• Konzeptionierung des Use Cases und Ableitung von IT-Architekturen sowie möglicher Blockchain Plattformen<br/>• Erstellen eines Prototypen mittels Solidity in der ETH-Blockchain</p> ',
      how_to_find_us: 'Check-in im 1. OG',
      visibility: 'public'
    },
    {
      created: 1555421464000,
      duration: 7200000,
      id: '260668963',
      name: 'Building Smarter IoT Products with Edge AI - Talks by Intel, Microsoft and TI',
      rsvp_limit: 200,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1559146500000,
      local_date: '2019-05-29',
      local_time: '18:15',
      updated: 1555494078000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 26,
      group: {
        created: 1490683239000,
        name: 'Munichs robotics meetup',
        id: 23035493,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munichs-robotics-meetup',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munichs-robotics-meetup/events/260668963/',
      description: '<p>In order to participate, you must download your FREE TICKET here (<a href="https://cli.re/LoWByr" class="linkified">https://cli.re/LoWByr</a>). If you only register on Meetup.com you won’t be eligible to attend the event and won’t be able to know the venue. Thank you!</p> <p>This event is organised in collaboration with Hardware Pioneers (<a href="https://hardwarepioneers.com" class="linkified">https://hardwarepioneers.com</a>).</p> <p>AI is moving towards edge devices, making connected things become even more intelligent. Curious about discovering how Edge AI can bring huge benefits to your IoT design? Then join us<br/>on the 29th of May to learn more from:<br/>- One of the top ten semiconductor companies worldwide (Texas Instruments).<br/>- The world\'s largest semiconductor chip maker (Intel).<br/>- One of the biggest multinational technology companies and the creator of the Azure IoT platform<br/>(Microsoft).</p> <p>Drinks and pizza will be served throughout the night.</p> ',
      visibility: 'public'
    },
    {
      created: 1554903176000,
      duration: 21540000,
      id: '260505169',
      name: 'BSH Future Home Demo Day - powered by Techstars',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557417600000,
      local_date: '2019-05-09',
      local_time: '18:00',
      updated: 1554903187000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 37,
      venue: {
        id: 26286188,
        name: 'Mathäser Filmpalast',
        lat: 48.13914489746094,
        lon: 11.563968658447266,
        repinned: false,
        address_1: 'Bayerstraße 3-5',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1491205628000,
        name: 'Munich Tech',
        id: 23120315,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Munich-Tech',
        who: 'Members',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/Munich-Tech/events/260505169/',
      description: '<p>*** REGISTRATION ON EVENTBRITE MANDATORY ***</p> <p>&gt;&gt;&gt; <a href="https://techstarsbshdemoday2019.eventbrite.com" class="linkified">https://techstarsbshdemoday2019.eventbrite.com</a> &lt;&lt;&lt;</p> <p>Are you interested in hearing about the latest developments in Future Home and Connected Kitchen innovations?</p> <p>Join us for the BSH Future Home Accelerator Powered by Techstars Demo Day as our founders share the innovative companies and the products and services they are building.</p> <p>Agenda:</p> <p>18:00 Doors Open &amp; Registration<br/>19:00 Welcoming remarks &amp; company presentations<br/>21:00 - 23:59 Networking &amp; Afterparty</p> ',
      visibility: 'public'
    },
    {
      created: 1554664387000,
      duration: 7200000,
      id: '260427919',
      name: 'DevOps is neither the Answer nor the Question!',
      rsvp_limit: 75,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1559754000000,
      local_date: '2019-06-05',
      local_time: '19:00',
      updated: 1555436986000,
      utc_offset: 7200000,
      waitlist_count: 19,
      yes_rsvp_count: 88,
      venue: {
        id: 26056635,
        name: 'MaibornWolff GmbH',
        lat: 48.133201599121094,
        lon: 11.54609203338623,
        repinned: true,
        address_1: 'Theresienhöhe 13',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1391009463000,
        name: 'DevOps Munich',
        id: 12572892,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'DevOpsMunich',
        who: 'DevOps',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/DevOpsMunich/events/260427919/',
      description: '<p>DevOps: Ist das Kunst oder kann das weg? Eine knappe Dekade ist das Buzzword alt. In dieser Zeit ist das unscharfe Buzzword zu einem handfesten Thema geworden, das in etlichen Unternehmen sehr ernsthaft diskutiert wird und viel Sinn stiftet. Denn DevOps ist viel mehr als eine Gruppentherapie für frustrierte ITler mit neuen fancy Tools! Es betrifft mindestens den kompletten Arbeitsalltag. Ein Kultur-Refactoring, das es in sich hat und in besonders großen Projekten besonders große technische und organisatorische Herausforderungen mit sich bringt.</p> <p>An welchen Stellen bei der Einführung von DevOps-Methoden kann es zu Problemen kommen? Was sind die technischen Symptome? Bei welchen Problemen liegt die Ursache dagegen gar nicht in der Technik? Wie kann man sich der Problemlösung annähern? Dieser Vortrag bietet keine DevOps-Einführung, sondern geht dorthin, wo es beim Einsatz in großen Projekten, lange nach der vermeintlichen Einführung, weh tut. Wir identifizieren potentielle Ursachen und diskutieren mögliche Auswege.</p> <p>## Links</p> <p><a href="https://talks.arbe.io" class="linkified">https://talks.arbe.io</a> (Slides)<br/><a href="https://feedback.arbe.io" class="linkified">https://feedback.arbe.io</a> (Feedback)<br/><a href="https://twitter.com/arnisoph" class="linkified">https://twitter.com/arnisoph</a> (Twitter)</p> <p>## Vorkenntnisse</p> <p>Existierende praktische Erfahrung in der (agilen) Entwicklung und im Betrieb von skalierenden bzw. hochverfügbaren Anwendungen helfen beim Verständnis der vorgetragenen Herausforderungen.</p> <p>## Lernziele</p> <p>Behandelt werden untechnische weiche Faktoren, die zu Misserfolgen im Tagesgeschäft führen, trotz und vielleicht wegen des Einsatzes von DevOps-Methoden.</p> <p>## Speaker Bio</p> <p>Arnold uses great technologies to move companies in Germany beyond #Neuland. As Senior Systems Engineer at inovex he\'s working on software-defined datacenter management, continuous integration/delivery, getting rid of the *legacy stuff* and is especially interested in system &amp; software architecture. At the end of the day he loves to get outside with his MTB.</p> ',
      how_to_find_us: 'The room for our meetup is on the 5th floor. 🏢',
      visibility: 'public'
    },
    {
      local_time: '19:00',
      local_date: '2019-05-21',
      link: 'https://www.meetup.com/Software-Performance-Meetup-Group/events/259928984/',
      visibility: 'public_limited',
      group: {
        created: 1400662449000,
        name: 'Software Performance Meetup Group',
        id: 14586172,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'Software-Performance-Meetup-Group',
        who: 'Performance Management Worker',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      waitlist_count: 0,
      yes_rsvp_count: 45,
      duration: 7200000,
      time: 1558458000000,
      utc_offset: 7200000,
      name: '19th Software Performance Meetup',
      id: '259928984'
    },
    {
      created: 1555333391000,
      duration: 19800000,
      id: '260639431',
      name: 'Google I/O Extended Munich 2019, 2nd Location at 1&1',
      rsvp_limit: 90,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557243000000,
      local_date: '2019-05-07',
      local_time: '17:30',
      updated: 1555485985000,
      utc_offset: 7200000,
      waitlist_count: 0,
      yes_rsvp_count: 35,
      venue: {
        id: 26051667,
        name: '1&1 Company',
        lat: 48.16843032836914,
        lon: 11.537059783935547,
        repinned: true,
        address_1: 'Sapporobogen 6-8',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1448316136000,
        name: 'GDG Munich Android',
        id: 19149051,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'GDG-Munich-Android',
        who: 'Humble Android Coders',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/GDG-Munich-Android/events/260639431/',
      description: '<p>***** Please note, there are two GDG Munich I/O events: *****<br/>***** Check which location you are RSVP\'d for *****</p> <p>Google I/O 2019! Let\'s enjoy the live stream of the event together at 1&amp;1 in Munich.</p> <p>Your host and contact at 1&amp;1 is Christoph Klar ([masked]).</p> <p>Preliminary Agenda:<br/>17:30 Arrival, networking, food &amp; drinks<br/>19:00 Key Note<br/>20:45 TBD / Lightning talks (5-7 minutes, contact us if you want to present!)<br/>21:45 Developer Key Note<br/>22:45 End</p> <p>NOTE: If you are attending, we need your first and last name. If your meetup profile does not show your real name, please change that or reach out to us and tell us. This is required for attending the meeting.</p> <p>Lightning talks: Please reach out to us if you would like to present. Tell us about your topic (send slides if you have already them or just a very short outline otherwise) and how long your talk will be. Your topic should also consider that we are expecting a mixed group including "non-Android" people.</p> <p>***** Please note, there are two GDG Munich I/O events: *****<br/>***** Check which location you are RSVP\'d for *****</p> ',
      visibility: 'public',
      pro_is_email_shared: false
    },
    {
      created: 1555007688000,
      duration: 7200000,
      id: '260545051',
      name: 'DevOps Meetup May 2019',
      rsvp_limit: 70,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1557162000000,
      local_date: '2019-05-06',
      local_time: '19:00',
      updated: 1555147720000,
      utc_offset: 7200000,
      waitlist_count: 42,
      yes_rsvp_count: 70,
      venue: {
        id: 26082467,
        name: 'codecentric AG',
        lat: 48.13685989379883,
        lon: 11.523862838745117,
        repinned: true,
        address_1: 'Elsenheimerstraße 55A',
        city: 'München',
        country: 'de',
        localized_country_name: 'Germany'
      },
      group: {
        created: 1391009463000,
        name: 'DevOps Munich',
        id: 12572892,
        join_mode: 'open',
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: 'DevOpsMunich',
        who: 'DevOps',
        localized_location: 'München, Germany',
        state: '',
        country: 'de',
        region: 'en_US',
        timezone: 'Europe/Berlin'
      },
      link: 'https://www.meetup.com/DevOpsMunich/events/260545051/',
      description: '<p># Continuous Delivery like you know no fear</p> <p>Warning: This talk can make your own release process seem awfully slow and risky! Everybody does Continuous Integration - more or less, but I think a modern CD pipeline can fundamentally change the way we are collaborating while building Software. At Matmatch we\'re pushing the boundaries of what Continuous Delivery can be by leveraging Gitlab and Kubernetes: Every Branch gets deployed into its own environment - and the Product Manager or the Stakeholder can release every feature directly to production with the click of a button. We don\'t bundle releases anymore, every feature goes straight to production. Goodbye test systems, good riddance staging processes.</p> <p>Why did we, as a small startup, bother with pushing that system to its limits? To get faster feedback and to minimize risk! By releasing and failing faster than the rest, we are outpacing others when it comes to opportunities to learn. It\'s a joy to work that way and and we could never imagine going back.</p> <p>In this talk I will walk you through our pipeline, the hiccups we had along the way to build it and the benefits we get from having this pipeline in place.</p> <p>## Speaker Bio</p> <p>Chris was a senior software consultant for a few years before he joined Matmatch as Head of Engineering, where he saw a huge variety of distributed systems and made a huge variety of mistakes that he can share now. He is especially interested in distributed systems, microservice architectures and always curious about how all these pieces fit together</p> ',
      visibility: 'public'
    }
  ]
};
export { mockEvents };
